import React, { useState } from 'react';
import { IMG } from './shared';

const AUDIENCES = [
  {
    label: 'Independent Rental Operators',
    tooltip:
      'Replace disconnected tools, paperwork, and manual follow up with one connected rental operation. Manage bookings, payments, agreements, embedded insurance, driver verification, active license checks, fleet activity, violations, and claims without adding more work to your day.',
  },
  {
    label: 'New Rental Businesses',
    tooltip:
      'Get started for free, build your rental business quickly, and begin renting the same day. Your storefront, bookings, payments, agreements, verification, and insurance workflows are already built in, so you can launch on your own time and grow without changing platforms later.',
  },
  {
    label: 'Marketplace Hosts & Digital Rental',
    tooltip:
      'Take control of your rental business with your brand front and center. Accept private and direct bookings with embedded insurance, built in verification, payments, collections, and resolution tools. Bring in leads from OTAs, local channels, and online marketing while deciding which renters are right for your business.',
  },
  {
    label: 'Physical Storefront Rental Agencies',
    tooltip:
      'Let renters complete verification, agreements, payments, and check in before they arrive. Your team can manage trip changes, send messages, collect balances, and access documents without printing paperwork, repeating information, or creating another line at the counter.',
  },
  {
    label: 'Rideshare and Gig Rental Fleets',
    tooltip:
      "Give qualified drivers faster access to your vehicles with built in identity, license, DMV, insurance, and rideshare platform verification. Collect weekly or monthly payments, issue insurance cards in the driver's name, keep every driver's information in one account, communicate in real time, and provide integrated roadside assistance to keep them moving.",
  },
  {
    label: 'Franchise and Multi-Location Operators',
    tooltip:
      'Give customers the fast, contactless experience they now expect across every location. Complete security checks before the trip, keep renters connected through live messaging during the rental, and resolve balances, violations, and claims faster afterward. Manage fleets, teams, and reporting from one place.',
  },
];

/** Two-column reveal list; opens on hover, focus, and click. */
const AudienceList = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <ul className="ilp-sizes-list" onMouseLeave={() => setOpenIndex(null)}>
      {AUDIENCES.map((item, i) => {
        const open = openIndex === i;
        return (
          <li
            key={item.label}
            className={`ilp-sizes-item${i === 0 ? ' is-first' : ''}${i === 1 ? ' is-second' : ''}`}
          >
            <button
              type="button"
              onMouseEnter={() => setOpenIndex(i)}
              onFocus={() => setOpenIndex(i)}
              onClick={() => setOpenIndex((prev) => (prev === i ? null : i))}
              className={`ilp-sizes-btn${open ? ' is-open' : ''}`}
              aria-expanded={open}
            >
              <span className="ilp-sizes-row">
                <span className="ilp-sizes-line" aria-hidden="true" />
                <span className="ilp-sizes-label">{item.label}</span>
              </span>

              {/* grid-rows 1fr/0fr collapse — no height measurement needed */}
              <span className="ilp-sizes-reveal">
                <span className="ilp-sizes-reveal-clip">
                  <span className="ilp-sizes-copy">{item.tooltip}</span>
                </span>
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

/** "Modern Mobility Operators" — segment list over an aerial photo. */
const BusinessSizes = () => (
  <section>
    <div className="ilp-sizes">
      <p className="ilp-eyebrow">Modern Mobility Operators</p>

      <div className="ilp-sizes-head">
        <h2 className="ilp-sizes-title">
          Powering rental commerce for businesses of all sizes and from all segments.
        </h2>
        <p className="ilp-sizes-sub">
          Run your rental fleet on a reliable, automated platform built for one or thousands of vehicles.
        </p>
      </div>

      <AudienceList />

      <div className="ilp-sizes-photo">
        <img
          src={`${IMG}/inshur/intersection-aerial.png`}
          alt="Aerial view of a busy city intersection with vehicles crossing"
        />
      </div>
    </div>
  </section>
);

export default BusinessSizes;
